import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[trimLeadingWhitespace]'
})
export class TrimLeadingWhitespaceDirective {
  constructor(private readonly el: ElementRef, private readonly control: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const trimmedValue = input.value.replace(/^\s+/, '');
    input.value = trimmedValue;
    this.control.control?.setValue(trimmedValue, { emitEvent: false });
    this.control.control?.updateValueAndValidity();
  }
}
